<section class="logout">
  <h1>Signing out...</h1>
  <p>If you are not redirected automatically, refresh the page.</p>
</section>
